import React from 'react';
import PropTypes from 'prop-types';
import DeleteRoom from './DeleteRoomConnector';
import DuplicateContainer from './DuplicateContainerConnector';

const ContainerActionsBar = ({ containerId, invalidItemsCount, disableDuplicate }) => (
  <div className="containerActionsBar">
    {invalidItemsCount === 0 &&
      !disableDuplicate && <DuplicateContainer containerId={containerId} />}
    <DeleteRoom containerId={containerId} />
  </div>
);

ContainerActionsBar.propTypes = {
  containerId: PropTypes.string.isRequired,
  invalidItemsCount: PropTypes.number.isRequired,
  disableDuplicate: PropTypes.bool.isRequired,
};

export default ContainerActionsBar;
